import * as AutomationsMethods from './automations';

export default {
	...AutomationsMethods,
};
